<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <i class="fa fa-question-circle text-light my-auto fa-2x" (click)="guid()"></i>

    </div>
</div>
<div class="position-absolute index d-flex justify-content-center flex-warp" style="right: 0; left: 0;"
    *ngIf="!Plak && !isReport">
    <div class="form-check col-4 d-flex flex-row mt-1">
        <div class="col-4 dirI">
            <select class="form-select" id="IOUsage" (change)="search()">
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of IOUsage" value="{{item.iIOUsage}}">{{item.strComment}}</option>
            </select>
        </div>
    </div>
    <div class="col-4 d-flex justify-content-center mt-1">
        <div class="col-4 dirI">
            <select class="form-select" id="domain" (change)="search()">
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            </select>
        </div>
    </div>
</div>

<div class="position-absolute index d-flex justify-content-center flex-warp" style="right: 0; left: 0;"
    *ngIf="!Plak && isReport">
    <div class="form-check col-4 d-flex flex-row mt-1">
        <div class="col-4 dirI">
            <select class="form-select" id="carype" (change)="searchReport()">
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of carTypes" value="{{item.tiMobileType}}">{{item.strComment}}</option>
            </select>
        </div>
    </div>
    <div class="col-4 d-flex justify-content-center mt-1">
        <div class="col-4 dirI">
            <select class="form-select" id="domain" (change)="searchReport()">
                <option value="-1">انتخاب کنید</option>
                <option *ngFor="let item of domain" value="{{item.iMobileDomain}}">{{item.strComment}}</option>
            </select>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center w-100 mt-3">
    <div class=" px-3 rounded text-white index bg-primary position-absolute f14">
        <p class="my-0 py-1 f22" *ngIf="Name"><span>{{Name}}</span></p>
    </div>
</div>
<div class="d-flex justify-content-center w-100 mt-3">
    <div class=" px-3 rounded text-white index bg-primary position-absolute f14 bl">
        <p class="my-0 py-1 f22 dirI" *ngIf="speed ||speed=='0'"><span>{{speed}}</span><span> کیلو متر </span> </p>
    </div>
</div>
<div class="d-flex justify-content-center w-100 mt-3">
    <div class=" px-3 rounded text-white index bg-primary position-absolute f14 br">
        <p class="my-0 py-1 f22" *ngIf="Plak"><span>{{Plak}}</span></p>
    </div>
</div>
<div id="test" class="fixed-map3">
    <div class="position-absolute" data-bs-html="true" id="map_tooltip">
    </div>
</div>
<img src="../../../assets/Img/layer-icon.png" title="تغییر نوع نقشه" (click)="changeTail()" class="bg-third p-2 circel-2 my-1 text-center pointer text-white icon-Img 
 r-0 index position-absolute">


<!-- Modal -->
<div class="modal fade rtl " id="datePickerModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content ">
            <div class="modal-header">
                <h5 class="modal-title" id="">انتخاب تاریخ</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body col-12 d-flex flex-wrap justify-content-around">
                <div class="col-md-3 col-6 ">
                    <label class="mb-2">از تاریخ</label>
                    <form [formGroup]="datasabt">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="azDate" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>
                </div>

                <div class="col-md-3 col-6 ">
                    <label class="mb-2">تا تاریخ</label>
                    <form [formGroup]="datasabt">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="taDate" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" (click)="viewReport()">تایید <i class="fa fa-angle-double-down"></i>
                </button>
                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>